import Vue from 'vue'
import moment from "moment";
import accounting from "accounting";
import VuetableFieldSequence from 'vuetable-2/src/components/VuetableFieldSequence.vue'
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue'
Vue.component('vuetable-field-checkbox', VuetableFieldCheckbox)

export default [
 
  // {
  //   name: 'vuetable-field-checkbox',
  //   title: "checkbox",
  //   width: "5%"
  // },
  {
    name: "type",
    title: 'Description',
    width: "80%",
    sortField: "type"
  },
  
  {
    name: "custom-actions",
    title: "Actions",
    width: "10%",
   

}
]